export const orderAccounts = balanceUser => balanceUser.sort((a, b) => b.IsMaster - a.IsMaster);
